import { Phone } from "lucide-react";

const CallButton = () => (
  <a
    href="tel:+919952493907"
    aria-label="Call Us"
    className="fixed bottom-4 left-4 sm:bottom-6 sm:left-6 z-50 w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#1e810a] flex items-center justify-center shadow-[0_8px_32px_rgba(0,0,0,0.3)] hover:scale-110 transition-transform"
  >
    <Phone className="w-7 h-7 sm:w-8 sm:h-8 text-white fill-white" />
  </a>
);

export default CallButton;
